import { Box, BoxProps } from "@chakra-ui/react";

interface CollapseIconProps extends BoxProps {
  width?: number | string;
  height?: number | string;
}

export function CollapseIcon({
  width = 20,
  height = 20,
  ...props
}: CollapseIconProps) {
  return (
    <Box {...props}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 15 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.5 0C13.8807 0 15 1.11929 15 2.5V12.5C15 13.8807 13.8807 15 12.5 15H2.5C1.11929 15 0 13.8807 0 12.5V2.5C0 1.11929 1.11929 0 2.5 0H12.5ZM6.1499 13.3333H12.5C12.9602 13.3333 13.3333 12.9602 13.3333 12.5V2.5C13.3333 2.03976 12.9602 1.66667 12.5 1.66667H6.1499V13.3333ZM2.5 1.66667C2.03976 1.66667 1.66667 2.03976 1.66667 2.5V12.5C1.66667 12.9602 2.03976 13.3333 2.5 13.3333H4.48324V1.66667H2.5Z"
          fill="currentColor"
        />
      </svg>
    </Box>
  );
}
